import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { MaintAdminsGuard } from './shared/guards/maint-admins.guard';
import { EnsembleGuard } from './shared/guards/ensemble.guard';
import { AUTH_GUARDS } from './shared/guards/auth-guards';

const routerDefinitions: Routes = [
  {
    path: AppRoutes.COMPONENTS_PAGE,
    data: { breadcrumb: 'Contracts' },
    loadChildren: () => import('./arsenal-components/arsenal-components.module').then((m) => m.ArsenalComponentsModule),
    // FOR SSO
    canActivate: [...AUTH_GUARDS, MaintAdminsGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: AppRoutes.AEM_PAGE,
    data: { breadcrumb: 'Exception Messages' },
    loadChildren: () => import('./aem/aem.module').then((m) => m.AemModule),
    // FOR SSO
    canActivate: [...AUTH_GUARDS, MaintAdminsGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: AppRoutes.ENSEMBLE_CONFIG_PAGE,
    data: { breadcrumb: 'Ensemble Configs' },
    loadChildren: () => import('./ensemble-config/ensemble-config.module').then((m) => m.EnsembleConfigModule),
    // FOR SSO
    canActivate: [...AUTH_GUARDS, EnsembleGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: AppRoutes.COMPONENT_OWNERSHIP,
    data: { breadcrumb: 'Component Ownership' },
    loadChildren: () =>
      import('./component-ownership/component-ownership.module').then((m) => m.ComponentOwnershipModule),
    // FOR SSO
    canActivate: [...AUTH_GUARDS],
  },
  {
    path: '',
    redirectTo: AppRoutes.COMPONENTS_PAGE,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routerDefinitions, {
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
